import React from 'react';
import {NodeProps, useReactFlow} from 'reactflow';

import {RouterNodeData} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import {BenchlingNodeV2} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNode';

import createHeaderPropsForNode from './createHeaderPropsForNode';
import {getNodeAndRowStatusAndDescription} from './nodeUtils';

export default function RouterNodeRenderer(props: NodeProps<RouterNodeData>): JSX.Element {
  const {data, xPos, yPos, id} = props;
  const reactFlowInstance = useReactFlow();
  const {isDisabled, onNodeHeaderClick} = data;

  const finalHeaderProps = createHeaderPropsForNode(
    {
      ...data,
      position: {x: xPos, y: yPos},
    },
    reactFlowInstance
  );

  const handleHeaderClick = (): void => {
    onNodeHeaderClick?.(id);
  };

  const {nodeStatus, nodeDescription} = getNodeAndRowStatusAndDescription(data.validationErrors);
  return (
    <div onClick={handleHeaderClick} style={{cursor: onNodeHeaderClick != null ? 'pointer' : 'default'}}>
      <BenchlingNodeV2.Standard.Node
        isSelected={props.selected}
        isDisabled={isDisabled}
        status={nodeStatus}
        statusDescription={nodeDescription}
        headerProps={finalHeaderProps}
        width={data.nodeWidth}
        dataTestAttrs={{
          element: 'RouterNodeRenderer',
          key: id,
        }}
      />
    </div>
  );
}
